import Blockly from "blockly";

export const menu = {
  'input_number': {
    name: (<div className="text"><u>N</u>umber</div>),
    trigger: 'n',
  },
  'input_string': {
    name: (<div className="text"><u>S</u>tring</div>),
    trigger: 's',
  },
}

/* ****************************************************************************************************************
 * Number
 *
 * Specifies a Number input block
 ******************************************************************************************************************/
Blockly.Blocks['input_number'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField(
        new Blockly.FieldTextInput(
          '1',
          this.validateCount.bind(this)
        ),
        'Number'
      )
    this.setOutput(true, ['number'])

    if (!this.data) {
      this.setMinimum(-100000)
      this.setMaximum(100000);
    }
  },
  onchange: function (event) {
    if (this.data) {
      const data = JSON.parse(this.data);
      this.minimum = data.minimum;
      this.maximum = data.maximum;
    }
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  setMinimum: function (value) {
    this.minimum = value;
    this.data = JSON.stringify({
      minimum: this.minimum,
      maximum: this.maximum,
    })
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  setMaximum: function (value) {
    this.maximum = value;
    this.data = JSON.stringify({
      minimum: this.minimum,
      maximum: this.maximum,
    })
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  validateCount: function (value) {
    let re = new RegExp('^[-0-9.]+$');
    if (!re.test(value)) {
      return null;
    } else {
      let num = parseFloat(value, 10);
      if (num < this.minimum) return null;
      if (num > this.maximum) return null;
    }
  },
}

Blockly.JSON['input_number'] = (block) => {
  let value = block.getFieldValue(block.inputList[0].fieldRow[0].name);
  return {
    value: parseFloat(value, 10)
  }
}

/* ****************************************************************************************************************
 * String
 *
 * Specifies a String input block
 ******************************************************************************************************************/
Blockly.Blocks['input_string'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField(
        new Blockly.FieldTextInput(
          'your text here',
          this.validateString.bind(this)
        ),
        'String'
      )
    this.setOutput(true, ['string']);

    if (!this.data) {
      this.setMaxLength(250);
    }
  },
  onchange: function (event) {
    if (this.data) {
      const data = JSON.parse(this.data);
      this.maxLength = data.maxLength;
    }
  },
  setMaxLength: function (value) {
    this.maxLength = value;
    this.data = JSON.stringify({
      maxLength: value,
    });
  },
  validateString: function (value) {
    if (value.length > this.maxLength) {
      return null;
    }
  },
};

Blockly.JSON['input_string'] = (block) => {
  let value = block.getFieldValue(block.inputList[0].fieldRow[0].name);
  return {
    string: value
  }
};
